import * as React from "react";
import { AsButton, AsInput, AsIconButton, DialogLayout } from "app/subframe";

export interface CredsConfirmModalProps {
  isOpen: boolean;
  onOpenChange: (show: boolean) => void;
  onSubmit: (data: any) => void;
}

export const CredsConfirmModal: React.FC<CredsConfirmModalProps> = ({
  isOpen,
  onOpenChange,
  onSubmit,
}) => {
  return (
    <DialogLayout
      open={isOpen}
      onOpenChange={onOpenChange}
      className="rounded px-8 py-12 z-[1000]"
    >
      <div className="flex relative flex-col h-64 w-112 py-4 mobile:w-full items-center px-8">
        <AsIconButton
          name="FeatherX"
          variant="ghost"
          size="xs"
          className="absolute top-4 right-4"
          onClick={() => onOpenChange(false)}
        />

        <h2 className="text-xl w-full font-semibold mb-8">
          Please confirm your password
        </h2>

        <form className="flex flex-col w-full gap-6" onSubmit={onSubmit}>
          <AsInput
            name="password"
            placeholder="Enter your password"
            label="Password"
            textPosition="left"
            required
            type="password"
          />

          <AsButton type="submit" className="w-full mt-4" text="Confirm" />
        </form>
      </div>
    </DialogLayout>
  );
};
